import React from "react";
import { useTheme, Theme } from "@mui/material/styles";
import SvgIcon from "@mui/material/SvgIcon";
import { PropsAdronIcon } from "../../../_app/types";

// Компонент TetherIcon
const PlusIcon = ({ size }: PropsAdronIcon) => {
  const theme: Theme = useTheme();
  return (
    <SvgIcon
      viewBox={size ? `0 0 ${size} ${size}` : undefined}
      style={size ? { width: size, height: size } : undefined}
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.39995 8.9H8.89995V8.4V3.3C8.89995 3.24477 8.94473 3.2 8.99995 3.2C9.05518 3.2 9.09995 3.24477 9.09995 3.3V8.4V8.9H9.59995H14.7C14.7552 8.9 14.8 8.9448 14.8 9C14.8 9.0552 14.7552 9.1 14.7 9.1H9.59995H9.09995V9.6V14.7C9.09995 14.7552 9.05515 14.8 8.99995 14.8C8.94475 14.8 8.89995 14.7552 8.89995 14.7V9.6V9.1H8.39995H3.29995C3.24473 9.1 3.19995 9.05522 3.19995 9C3.19995 8.94477 3.24473 8.9 3.29995 8.9H8.39995Z"
          fill={theme.palette.text.primary}
          stroke={theme.palette.text.primary}
        />
      </svg>
    </SvgIcon>
  );
};

export default PlusIcon;
